import React from 'react'
import PropTypes from 'prop-types'

/**
 * This is an abstract class so it doesn't need a render method
 */
class BasicViewComponent extends React.Component {

  constructor (props) {
    super(props)

    this.type = props.config.type
    this.cssClass = props.config.cssClass
  }

  componentWillReceiveProps (nextProps) {
    this.type = nextProps.config.type
    this.cssClass = nextProps.config.cssClass
  }

  conditionsAreMet () {
    if (this.props.config.condition) {
      return this.props.functions.eval(this.props.config.condition, this.props.poi)
    }
    return true
  }

  evalConfigValue = (textValue) => {
    return this.props.functions.eval(textValue, this.props.poi)
  }

  getCssClass () {
    return this.props.config.cssClass
  }

  onTouchTap = (e) => {
    if (e) {
      e.stopPropagation()
    }
    if (this.props.config.onclick) {
      this.props.functions.eval(this.props.config.onclick, this.props.poi, false, this.props.setCategoryVisible)
    }
  }

}

BasicViewComponent.propTypes = {
  config: PropTypes.object.isRequired,
  functions: PropTypes.object.isRequired,
  poi: PropTypes.object,
  setCategoryVisible: PropTypes.func
}

BasicViewComponent.defaultProps = {
  poi: null,
}

export default BasicViewComponent



// WEBPACK FOOTER //
// ./src/components/ViewComponents/BasicViewComponent.js